// Paletas de marca do Portal - fonte única usada tanto pelo tema do MUI
// (theme/index.js) quanto pelo tema do styled-components (styledThemeOn) pra
// não duplicar os mesmos hex em dois lugares. O roxo (MTW_*) é a marca
// Make the Way; LEVDATA_* é a paleta oficial da LevData (Navy + Coral, a
// mesma usada nos dashboards redesenhados). Qual das duas está "ativa" no
// tema compartilhado é decidido por App.js a cada navegação, conforme a
// rota é ou não /levdata - ver `applyBrandPalette` em cada um dos dois
// arquivos de tema.
export const MTW_PRIMARY = {
  main: '#A646DC',
  100: '#382059',
  200: '#923EC5',
  80: '#683CA6',
  60: '#9857F2',
  logo: '#9340C5'
};

export const MTW_ACCENT = {
  main: '#551778',
  100: '#D2A3ED',
  500: '#F8F0FC',
  text: '#A646DC'
};

export const LEVDATA_PRIMARY = {
  main: '#FF5465',
  100: '#251844',
  200: '#FF5465',
  80: '#D94756',
  60: '#FF8A95',
  logo: '#FF5465'
};

export const LEVDATA_ACCENT = {
  main: '#D94756',
  100: '#FFD9DD',
  500: 'rgba(255,84,101,.14)',
  text: '#251844'
};
